import { getDefaultDateRange } from "./date-utils";
import { getTemperatureReadingsBySensor } from "./requests";
import { LineChart } from "./charting";
import { UrlHelper, UrlHelperConfiguration } from "./url-helper";
import { LineChartToolbar } from "./line-chart-toolbar";

interface SensorDetailsConfiguration {
    ids: {
        chartElementId: string;
        chartToolContainerId: string;
    };
    pageConfiguration: SensorDetailsPageConfiguration;
    urlHelperConfiguration: UrlHelperConfiguration;
}

interface SensorDetailsPageConfiguration {
    sensorId: number;
    date: string;
    timeZoneId: string;
}

$(document).on("turbolinks:load", function() {
    const configElement = document.getElementById("sensor-details-config");
    if (configElement) {
        const config: SensorDetailsConfiguration = JSON.parse(configElement.innerHTML);
        const page = new SensorDetailsPage(config);
        $(document).one("turbolinks:before-render", () => page.destroy());
    }
});

export class SensorDetailsPage {
    private chart: LineChart | undefined;
    private urlHelper: UrlHelper;
    private chartToolbar: LineChartToolbar;

    constructor(private config: SensorDetailsConfiguration) {
        this.urlHelper = new UrlHelper(this.config.urlHelperConfiguration);

        const [initialChartStartDate, initialChartEndDate] = getDefaultDateRange(this.config.pageConfiguration.date && new Date(this.config.pageConfiguration.date));
        if (document.getElementById(this.config.ids.chartElementId)) {
            this.chart = new LineChart(
                this.config.ids.chartElementId,
                "focused",
                initialChartStartDate,
                initialChartEndDate,
                (fromDate, toDate) => getTemperatureReadingsBySensor(this.config.pageConfiguration.sensorId, fromDate, toDate),
                this.urlHelper,
                this.config.pageConfiguration.timeZoneId
            );
    
            
            this.chartToolbar = new LineChartToolbar(
                $(`#${config.ids.chartToolContainerId}`),
                this.chart,
                "down");
    
            this.chart.firstRender();
        } else {
            // element not present, probably because of subscription/license
        }
    }

    public destroy() {
        this.chart.destroy();
        delete this.chart;
        this.chartToolbar.destroy();
        delete this.chartToolbar;
    }
}
